import { dispatchAnalyticEvent } from '../../Global/analyticsEvents'
import type { TableRowCellButtonLink } from '../types/Table.type'

export function createButtonLinkCell(
  condensedSpacing: boolean,
  cell: TableRowCellButtonLink,
  componentName: string,
): HTMLTableCellElement {
  const td = document.createElement('td')
  td.part = 'cell'
  const buttonLink: TableRowCellButtonLink = cell as TableRowCellButtonLink
  const button = document.createElement('wa-button')
  button.part = 'cell-button'
  button.setAttribute('exportparts', 'base:cell-button-base')
  button.setAttribute('appearance', 'outlined')

  if (condensedSpacing) {
    button.setAttribute('size', 'small')
    td.classList.add('cell-button-condensed')
  }
  button.innerText = cell.text || ''
  button.setAttribute('href', buttonLink.link?.href || '#')
  if (buttonLink.link?.target) {
    button.setAttribute('target', buttonLink.link?.target || '_self')
  }

  button.addEventListener('click', () => {
    // Fire analytics event for cell click
    dispatchAnalyticEvent('ascend_table_cellbuttonlink_clicked', 'click', componentName, {
      label: `${button.innerText || 'unknown'}`,
    })
  })

  td.appendChild(button)

  return td
}
